import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a3eac47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column agent-license-filter--box-container" }
const _hoisted_2 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_3 = { class: "q-ml-md" }
const _hoisted_4 = {
  key: 0,
  class: "column"
}

import { computed, inject, watch } from 'vue';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { IKAgentsSelected } from '@/views/agents/components/agents-table/agents-table.InjectionKeys';
import { useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import IncrediCheckBox from '@/components/inputs/incrediCheckBox.vue';
import elementIds from '@/const/elementIds.json';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';


export default /*#__PURE__*/_defineComponent({
  __name: 'agents-license-filter.linux',
  props: {
    visibility: null
  },
  setup(__props: any) {

const props = __props as {
  visibility: {
    cloudAgent: boolean;
    helper: boolean;
    initiator: boolean;
  };
}



const agentsFilter = inject(IKAgentsDrawerFilter);
const coordinatorsService = inject(IKCoordinatorsService);
const selectedAgents = inject(IKAgentsSelected);
const GQL_commonData = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
const filtersState = computed(() => agentsFilter?.filter.value);

const initiator = computed({
  get: () => filtersState.value.licensesFilter.initiator,
  set: value => {
    agentsFilter?.updateFilter({
      osType: OsType.Linux,
      filter: 'initiator',
      group: 'licensesFilter',
      value,
    });
    agentsFilter?.setGQL_LinuxAgentsFilter('licenseFilter');
    selectedAgents?.clearSelection();
  },
});

const helper = computed({
  get: () => filtersState.value.licensesFilter.helper,
  set: value => {
    agentsFilter?.updateFilter({
      osType: OsType.Linux,
      filter: 'helper',
      group: 'licensesFilter',
      value,
    });
    agentsFilter?.setGQL_LinuxAgentsFilter('licenseFilter');
    selectedAgents?.clearSelection();
  },
});

const bothHelperAndInitiator = computed({
  get: () => filtersState.value.licensesFilter.bothHelperAndInitiator,
  set: value => {
    agentsFilter?.updateFilter({
      osType: OsType.Linux,
      filter: 'bothHelperAndInitiator',
      group: 'licensesFilter',
      value,
    });
    agentsFilter?.setGQL_LinuxAgentsFilter('licenseFilter');
    selectedAgents?.clearSelection();
  },
});

const cloudAgent = computed({
  get: () => filtersState.value.licensesFilter.cloudAgent,
  set: value => {
    agentsFilter?.updateFilter({
      osType: OsType.Linux,
      filter: 'cloudAgent',
      group: 'licensesFilter',
      value,
    });
    agentsFilter?.setGQL_LinuxAgentsFilter('licenseFilter');
    selectedAgents?.clearSelection();
  },
});

const allCheckbox = computed({
  get: () => {
    const checkboxes = [initiator.value, helper.value, bothHelperAndInitiator.value];
    if (props.visibility.cloudAgent) checkboxes.push(cloudAgent.value);
    if (checkboxes.every(checkbox => checkbox)) {
      agentsFilter?.clearGQL_AgentsFilter(['licenseFilter']);
      return true;
    }
    if (checkboxes.some(checkbox => checkbox)) return null;
    return false;
  },
  set: val => {
    initiator.value = val;
    helper.value = val;
    cloudAgent.value = val;
    bothHelperAndInitiator.value = val;
  },
});

const allHelpers = computed({
  get: () => {
    const allHelpersValues = [helper.value];
    if (props.visibility.cloudAgent) allHelpersValues.push(cloudAgent.value);
    if (allHelpersValues.every(e => e)) return true;
    if (allHelpersValues.some(e => e)) return null;
    return false;
  },
  set: val => {
    helper.value = val;
    cloudAgent.value = val;
  },
});

const cloudStatus = computed(() => GQL_commonData?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus);

watch(
  () => cloudStatus.value,
  (newValue, oldValue) => {
    if (newValue === 'Disabled') {
      agentsFilter?.updateFilter({
        osType: OsType.Linux,
        filter: 'cloudAgent',
        group: 'licensesFilter',
        value: undefined,
      });
    }
    // the use of the old value here is to make sure this watch only happens the moment the user unlocks the cloud and the status goes from disabled to enabled.
    if (newValue === 'Enabled' && oldValue === 'Disabled') {
      agentsFilter?.updateFilter({
        osType: OsType.Linux,
        filter: 'cloudAgent',
        group: 'licensesFilter',
        value: true,
      });
    }
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IncrediCheckBox, {
        value: _unref(allCheckbox),
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_isRef(allCheckbox) ? (allCheckbox).value = $event : null)),
        label: "All",
        "data-role": "all-checkbox",
        "data-testid": _unref(elementIds).agents.filtersMenu.licenseType.all
      }, null, 8, ["value", "data-testid"]),
      (__props.visibility?.initiator !== false)
        ? (_openBlock(), _createBlock(IncrediCheckBox, {
            key: 0,
            value: _unref(initiator),
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(initiator) ? (initiator).value = $event : null)),
            label: "Only Initiator",
            "data-role": "initiator-checkbox",
            class: "q-ml-md"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (__props.visibility?.helper !== false)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(IncrediCheckBox, {
                value: _unref(allHelpers),
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(allHelpers) ? (allHelpers).value = $event : null)),
                label: "Only Helper",
                "data-role": "allHelpers-checkbox"
              }, null, 8, ["value"]),
              (__props.visibility.cloudAgent !== false)
                ? (_openBlock(), _createBlock(IncrediCheckBox, {
                    key: 0,
                    value: _unref(helper),
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_isRef(helper) ? (helper).value = $event : null)),
                    label: "On Prem",
                    "data-role": "helper-checkbox",
                    class: "q-ml-md"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (__props.visibility.cloudAgent !== false)
                ? (_openBlock(), _createBlock(IncrediCheckBox, {
                    key: 1,
                    value: _unref(cloudAgent),
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_isRef(cloudAgent) ? (cloudAgent).value = $event : null)),
                    label: "Cloud",
                    "data-role": "cloud-checkbox",
                    class: "q-ml-md"
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      (__props.visibility?.helper !== false && __props.visibility?.initiator !== false)
        ? (_openBlock(), _createBlock(IncrediCheckBox, {
            key: 1,
            value: _unref(bothHelperAndInitiator),
            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_isRef(bothHelperAndInitiator) ? (bothHelperAndInitiator).value = $event : null)),
            label: "Both Initiator & Helper",
            "data-role": "both-helper-and-initiator-checkbox",
            class: "q-ml-md"
          }, null, 8, ["value"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})